<template>
  <div class="mt90">
    <el-row class="pr-bgimg pr-bg-strengths"></el-row>
    <el-row class="pr-container bg-white mt-160 pb-6">
      <h2 class="page-title">核心优势</h2>
      <p class="page-sub-title">Advantages</p>
        <p class="text-center col666 line-h24">蒲睿在过往的信息技术服务中，积累了丰富的实战技术资源、专业人才资源，并构建了成熟的过程实施于质量管控体系，<br/>通过严谨的交付流程，SLA服务水平管理，确立了核心优势，服务客户。</p>
      <div class="pt-5 px-5 clear mw-img100">
        <el-col class="mb-5">
          <h2 class="font26 f-w500 col333 mb-2">交付优势</h2>
          <p class="m-0">严谨的交付流程</p>
          <div class="text-center pt-4"><img src="../../assets/images/strengths/1.png" alt=""></div>
        </el-col>
        <el-col class="mb-5">
          <h2 class="font26 f-w500 col333 mb-2">技术优势</h2>
          <p class="m-0">框架 | 架构 | 大数据 | 安全</p>
          <div class="text-center pt-4"><img src="../../assets/images/strengths/2.png" alt=""></div>
        </el-col>
        <el-col class="mb-5">
          <h2 class="font26 f-w500 col333">SLA | 服务水平管理</h2>
          <div class="text-center pt-4"><img src="../../assets/images/strengths/3.png" alt=""></div>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.pr-bg-strengths {
  background-image: url('../../assets/images/strengths/1481874603429.jpg');
}
</style>
